import { BRANDING_FORM_DEFAULTS } from "./constants";
// Color configuration is disabled — see BrandingForm.jsx / BrandingProvider.jsx.
// import { BRANDING_COLOR_DEFAULTS } from "./constants";

// const ensureHash = (v) => (v && !v.startsWith("#") ? `#${v}` : v || "");

export const mapAssetsByKind = (assets = []) => {
  return assets.reduce((acc, asset) => {
    acc[asset.assetKind] = asset;
    return acc;
  }, {});
};

export const mapCurrentToFormValues = (current) => {
  const source = current?.draft?.config || current?.published?.config || {};

  return {
    ...BRANDING_FORM_DEFAULTS,
    displayName: source?.displayName || "",
    // primaryColor: ensureHash(source?.primaryColor) || BRANDING_COLOR_DEFAULTS.primaryColor,
    // primaryColorContrast: ensureHash(source?.primaryColorContrast) || BRANDING_COLOR_DEFAULTS.primaryColorContrast,
    // primaryColorDark: ensureHash(source?.primaryColorDark) || BRANDING_COLOR_DEFAULTS.primaryColorDark,
    // primaryColorContrastDark: ensureHash(source?.primaryColorContrastDark) || BRANDING_COLOR_DEFAULTS.primaryColorContrastDark,
    expectedUpdatedAt: current?.draft?.updatedAt || null,
  };
};

export const mapBrandingState = (current) => {
  return {
    published: current?.published || null,
    draft: current?.draft || null,
    publishedAssets: mapAssetsByKind(current?.published?.assets || []),
    draftAssets: mapAssetsByKind(current?.draft?.assets || []),
    quotaBytes: current?.quotaBytes || 0,
    quotaUsedBytes: current?.quotaUsedBytes || 0,
  };
};
